/**
 * Created by dubinbin on 2018/7/12
 代替wktag组件*/

import React, {Component} from 'react';
import '../../css/page/ChannelPageItemTag.css'

class ChannelPageItemTag extends Component {
    render() {
        const tagName = this.props.tagName;

        return (
            <div className="tag channel-page-item-tag">
                <div className="tagInner">
                    <span className="tagItem">{tagName}</span>
                </div>
            </div>
        )
    }
}

export default ChannelPageItemTag;



// WEBPACK FOOTER //
// ./src/pages/channel/ChannelPageItemTag.js